import type { ActivityId, ActivityWithProgramCount } from '@gyym/sdk'
import { Swiper } from '@gyym/ui'
import Image from 'next/image'
import React from 'react'

import { ActivityChip, SwiperContainer } from './styles'

const getFormattedName = (name: string) => {
  switch (name) {
    case '暗闇フィットネス':
      return (
        <>
          暗闇
          <br />
          フィットネス
        </>
      )
    case 'サーフエクササイズ':
      return (
        <>
          サーフ
          <br />
          エクササイズ
        </>
      )
    case 'サーキットトレーニング':
      return (
        <>
          サーキット
          <br />
          トレーニング
        </>
      )
    case 'パーソナルトレーニング':
      return (
        <>
          パーソナル
          <br />
          トレーニング
        </>
      )
    case 'エステ・セルフエステ':
      return (
        <>
          エステ・
          <br />
          セルフエステ
        </>
      )
    default:
      return name
  }
}

const getActivityImg = (id: ActivityId) => {
  const num = ('0' + id).slice(-2)
  return `/assets/images/activity/bg_activityimg${num}@2x.png`
}

export interface ActivitySwiperProps {
  activities: ActivityWithProgramCount[]
}

const swiperOptions = {
  slidesPerView: 2,
  spaceBetween: 16,
  slidesPerGroup: 2,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  virtual: false,
  pagination: true,
  navigation: true,
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 16,
      slidesPerGroup: 2,
    },
    580: {
      slidesPerView: 3,
      spaceBetween: 16,
      slidesPerGroup: 2,
    },
    460: {
      slidesPerView: 2.2,
      spaceBetween: 8,
      slidesPerGroup: 2,
    },
    0: {
      slidesPerView: 1.2,
      spaceBetween: 8,
      slidesPerGroup: 1,
    },
  },
}

const ACTIVITIES_PER_SLIDE = 3

export const ActivitySwiper = ({ activities }: ActivitySwiperProps) => {
  const activitiesPerSlide = React.useMemo(
    () =>
      activities.reduce((acc, current, i) => {
        if (i % ACTIVITIES_PER_SLIDE === 0) {
          return [...acc, [current]]
        }

        return [
          ...acc.slice(0, acc.length - 1),
          [...(acc[acc.length - 1] ?? []), current],
        ]
      }, [] as ActivityWithProgramCount[][]),
    [activities],
  )

  return (
    <SwiperContainer>
      <Swiper
        id="ActivitySwiper"
        {...swiperOptions}
        slides={activitiesPerSlide.map((slideActivities, i) => (
          <div key={i} className="flex w-full min-w-[170px] flex-col pb-3">
            {slideActivities.map((activity, i) => (
              <div
                key={activity.name}
                className={`w-full ${i !== 0 ? 'mt-3' : ''}`}
              >
                <ActivityChip href={`/facilities?activityIds=${activity.id}`}>
                  <span>{getFormattedName(activity.name)}</span>
                  <Image
                    src={getActivityImg(activity.id)}
                    alt={activity.name}
                    fill
                    style={{
                      objectFit: 'cover',
                    }}
                  />
                </ActivityChip>
              </div>
            ))}
          </div>
        ))}
      ></Swiper>
    </SwiperContainer>
  )
}
